import { useEffect, useState } from 'react'

/** Update exactly after a known evidence cutoff and on returning to the page.
 * Relative-time labels update at most once a minute otherwise. No network poll. */
export function useEvidenceClock(expiresAt) {
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    const tick = () => setNow(Date.now())
    const delay = expiresAt !== null && expiresAt >= now ? Math.min(60000, expiresAt - now + 1) : 60000
    const timer = setTimeout(tick, delay)
    document.addEventListener('visibilitychange', tick)
    window.addEventListener('focus', tick)
    return () => { clearTimeout(timer); document.removeEventListener('visibilitychange', tick); window.removeEventListener('focus', tick) }
  }, [now, expiresAt])
  // A user-triggered render may run just before the scheduled timer. Evaluate
  // its display against the actual clock, not the preceding timer's state.
  return Date.now()
}
